import { LocalStorage } from "src/services/localStorageService";

import { createSlice } from "@reduxjs/toolkit";

import { RootState } from ".";

interface AppSlice {
    currentWorkspaceId: number | null;
    // Whether workspace resolution (picking the default workspace) has concluded — even when it
    // concludes to "no workspace". PageGuard waits on this before deciding a landing page, since
    // resolution happens in PrefetchGuard (below it) and a null id is otherwise ambiguous.
    isWorkspaceResolved: boolean;
}

const parsedId = Number(LocalStorage.getItem<string>("currentWorkspace"));
const initialState: AppSlice = {
    currentWorkspaceId: Number.isFinite(parsedId) && parsedId > 0 ? parsedId : null,
    isWorkspaceResolved: false,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setCurrentWorkspaceId: (state, action) => {
            LocalStorage.setItem("currentWorkspace", action.payload);
            state.currentWorkspaceId = action.payload;
        },
        setWorkspaceResolved: (state, action) => {
            state.isWorkspaceResolved = action.payload;
        },
    },
});

export const AppReducer = appSlice.reducer;

export const { setCurrentWorkspaceId, setWorkspaceResolved } = appSlice.actions;

export function selectCurrentWorkspaceId(state: RootState) {
    return state.app.currentWorkspaceId;
}

export function selectIsWorkspaceResolved(state: RootState) {
    return state.app.isWorkspaceResolved;
}
